export default "#### Online bank transfer\n\n2-3 business days. Bank fees may apply.\n";